import Vue from 'vue'
import { $$, sleep } from '../_utils'
// import products from '../../data/productNames'

const ANIMATION_DUATION = 300

Vue.component('vue-slotted-accordion', {
  template: '#vue-slotted-accordion-template',
  props: {
    open: Boolean,
    group: String,
    items: Array,
  },
  data() {
    return {
      isOpen: this.$props.open,
    }
  },
  methods: {
    closeAccordion,
    openAccordion,
    toggleAccordion,
    // generateProductsList,
  },
  mounted() {
    if (!this.isOpen) this.closeAccordion()
    // this.$refs.target.appendChild(generateProductsList(this.$props.group))
  },
})

async function closeAccordion() {
  const targetHeight = this.$refs.target.scrollHeight
  if (this.$refs.target) this.$refs.target.style.setProperty('height', `${targetHeight}px`)
  await sleep(100)
  this.isOpen = false
  if (this.$refs.target) this.$refs.target.style.setProperty('height', '0px')
}

async function openAccordion() {
  const targetHeight = this.$refs.target.scrollHeight
  await sleep(0)
  this.isOpen = true
  this.$refs.target.style.setProperty('height', `${targetHeight}px`)
  await sleep(ANIMATION_DUATION)
  this.$refs.target.style.setProperty('height', 'auto')
}

function toggleAccordion() {
  if (this.isOpen) this.closeAccordion()
  else this.openAccordion()
}

// function generateProductsList(color) {
//   const ul = document.createElement('ul')
//   ul.classList.add('sales-reps__group__products-list')
//   let list = []
//   for (const prod of products[color]) {
//     const li = document.createElement('li')
//     li.innerText = prod.name
//     li.classList.add('sales-reps__group__products-item')
//     list = [...list, li]
//   }
//   list.forEach(li => ul.appendChild(li))
//   return ul
// }

window.addEventListener('DOMContentLoaded', () => {
  $$('#vue-slotted-accordion').forEach(el => new Vue({ el }))
})
